import { useState, useEffect, useRef } from 'react';
import { api } from '../api';

export default function PropertySelector({ value, onChange, showCustomLocation = false }) {
  const [search, setSearch] = useState('');
  const [options, setOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef();

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (search.length < 1) { setOptions([]); return; }
    setLoading(true);
    const timeout = setTimeout(() => {
      api.getProperties({ search })
        .then(data => { setOptions(data); setShowDropdown(true); })
        .catch(console.error)
        .finally(() => setLoading(false));
    }, 300);
    return () => clearTimeout(timeout);
  }, [search]);

  function handleSelect(prop) {
    onChange(prop);
    setSearch(prop.name);
    setShowDropdown(false);
  }

  function handleClear() {
    onChange(null);
    setSearch('');
    setOptions([]);
  }

  // Show "Custom Location" in dropdown when applicable
  const customLocationMatch = showCustomLocation && (
    !search || 'custom location'.includes(search.toLowerCase())
  );

  return (
    <div className="property-selector" ref={wrapperRef}>
      <div className="property-input-wrap">
        <input
          type="text"
          placeholder="Search properties..."
          value={value ? value.name : search}
          onChange={e => { setSearch(e.target.value); if (value) onChange(null); }}
          onFocus={() => {
            if (showCustomLocation && !value) setShowDropdown(true);
            else if (options.length > 0) setShowDropdown(true);
          }}
        />
        {value && <button type="button" className="clear-btn" onClick={handleClear}>&times;</button>}
        {loading && <span className="spinner-sm" />}
      </div>
      {showDropdown && (customLocationMatch || options.length > 0) && (
        <ul className="property-dropdown">
          {customLocationMatch && (
            <li className="custom-location-option" onClick={() => handleSelect({ id: 'custom', name: 'Custom Location' })}>
              <strong>Custom Location</strong>
              <span>Enter a custom address</span>
            </li>
          )}
          {options.map(p => (
            <li key={p.id} onClick={() => handleSelect(p)}>
              <strong>{p.name}</strong>
              <span>{p.address}, {p.city} &mdash; {p.region}</span>
            </li>
          ))}
        </ul>
      )}
      {showDropdown && search.length > 0 && options.length === 0 && !customLocationMatch && !loading && (
        <ul className="property-dropdown">
          <li className="no-results">No properties found</li>
        </ul>
      )}
    </div>
  );
}
